// extracted by mini-css-extract-plugin
export default {"document-template":"DocumentTemplate_document-template__ZGOZ3"};